const WooCart = {
  qtyThrottle: undefined,
  el: $("#woo-cart"),

  init() {
    this.events();
  },

  events() {
    WooCart.el.on("change", ".quantity input", function (e) {
      if (WooCart.qtyThrottle) {
        return;
      }

      const inputEl = $(this);

      WooCart.qtyThrottle = setTimeout(() => {
        WooCart.changeQuantity(inputEl);
        WooCart.qtyThrottle = undefined;
      }, 1000);
    });
  },

  changeQuantity(inputEl) {
    WooCart.el.addClass("quick-cart--loading");

    const product_key = inputEl
      .closest("[data-product-key]")
      .attr("data-product-key");

    const product_qty = parseInt(inputEl.val());

    $.ajax({
      type: "POST",
      url: ajaxurl,
      data: {
        action: "handle_change_quantity",
        product_key,
        product_qty,
      },
    }).done((resp) => {
      WooCart.setCart(resp);
      WooCart.el.removeClass("quick-cart--loading");
    });
  },

  /**
   * Render quickcart
   **/
  render() {
    WooCart.open();
    WooCart.el.html(
      '<div class="quick-cart-loader"><div class="spinner"></div></div>'
    );

    $.ajax({
      url: ajaxurl,
      type: "POST",
      dataType: "JSON",
      data: {
        action: "render_quick_cart",
      },
    }).done((response) => {
      if (response) {
        WooCart.loaded();
        WooCart.el.html(response);
      } else {
        WooCart.close();
      }
    });
  },

  /**
   * Set cart item values
   */
  setCart(cart) {
    for (let index = 0; index < cart.items.length; index++) {
      const item = cart.items[index];

      const cartItemEl = $(`[data-product-key="${item.key}"]`);

      cartItemEl.find(".quantity__input").val(item.quantity);
      cartItemEl.find(".cart-item-price").html(item.price);
      if (cartItemEl.find(".cart-item-price-unit").length) {
        cartItemEl.find(".cart-item-price-unit").html(item.price_unit);
      }
      if (cartItemEl.find(".cart-item-price-old").length) {
        cartItemEl.find(".cart-item-price-old").html(item.regular_price);
      }
    }

    $(".cart .missing_progress").html(cart.progress_bar.missing.toFixed(2));
    $(".cart .progress .progress__value-current").html(cart.progress_bar.total.toFixed(2) + ' €');
    $(".cart .progress .progress__value-goal").html('/' + cart.progress_bar.needs.toFixed(2) + ' €');
    $(".cart .progress .progress__bar").attr('data-progress', cart.progress_bar.progress );

    if(cart.progress_bar.progress === 1) {
      $(".cart .progress-message").hide();
      WooCart.progressBar();
    } else {
      WooCart.progressBar();
      $(".cart .progress, .cart .progress-message").show();
    }

    if (cart.hasOwnProperty("fee_text")) {
      $(".cart-fee-no-vat-text").html(cart.fee_text);
      $(".cart-fee-no-vat").html(cart.fee);
      $(".cart-fee-wrap").show();
    } else {
      $(".cart-fee-wrap").hide();
    }

    $(".cart-vat").html(cart.tax);
    $(".cart-total").html(cart.total);
  },

  progressBar() {
    const bars = document.querySelectorAll('.progress__bar');
    bars.forEach((bar) => {
      let progress = parseFloat(bar.getAttribute("data-progress")) * 100;
      bar.style.width = `${progress}%`;
    })
  }
};
export default WooCart;
